import { useQuery } from '@tanstack/react-query';
import { Card, Input, Space, Table, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { api } from '../../api/client';
import type { AuditLog } from '../../api/types';

/** Nhật ký hệ thống (PRD 6.1 mục 15) – chỉ đọc. */
export function AuditPage() {
  const [page, setPage] = useState(1);
  const [action, setAction] = useState<string | undefined>();
  const list = useQuery({
    queryKey: ['audit', page, action],
    queryFn: () => api.page<AuditLog>('/admin/audit-logs', { page, limit: 30, action }),
  });
  return (
    <Card title="Nhật ký hệ thống">
      <Input.Search
        placeholder="Lọc theo hành động, vd: rental_prices.update"
        allowClear
        style={{ width: 360, marginBottom: 16 }}
        onSearch={(v) => (setAction(v.trim() || undefined), setPage(1))}
      />
      <Table<AuditLog>
        rowKey="id"
        size="small"
        loading={list.isLoading}
        dataSource={list.data?.items}
        pagination={{
          current: page,
          pageSize: 30,
          total: list.data?.meta.total,
          onChange: setPage,
        }}
        expandable={{
          expandedRowRender: (r) => (
            <Space align="start" style={{ width: '100%' }}>
              <pre style={{ fontSize: 11, maxWidth: 560, overflow: 'auto' }}>
                {JSON.stringify(r.before_data, null, 2)}
              </pre>
              <pre style={{ fontSize: 11, maxWidth: 560, overflow: 'auto' }}>
                {JSON.stringify(r.after_data, null, 2)}
              </pre>
            </Space>
          ),
        }}
        columns={[
          {
            title: 'Thời gian',
            render: (_, r) => dayjs(r.created_at).format('DD/MM/YYYY HH:mm:ss'),
          },
          { title: 'Người thực hiện', render: (_, r) => r.user?.full_name ?? '—' },
          {
            title: 'Hành động',
            dataIndex: 'action',
            render: (v: string) => <Typography.Text code>{v}</Typography.Text>,
          },
          { title: 'Đối tượng', dataIndex: 'entity_type' },
          { title: 'IP', dataIndex: 'ip_address' },
        ]}
      />
    </Card>
  );
}
